import customAssetsApi from '../api/customAssets'

export default {
    state: {
        customAssets:{},
        customAssetsTags:[],
        filters:[],
        availableId: null,
    },
    namespaced: true,
    mutations: {
        async getCustomAssets(state, customAssets) {
            state.customAssets = customAssets
        },
        getCustomAssetsTags(state, customAssetsTags) {
            state.customAssetsTags = customAssetsTags
        },
        getCustomAssetsFilterData(state, filterData) {
            state.filters = filterData.filters
        },
        deleteCustomAsset(state, id) {
            state.customAssets.data = state.customAssets.data.filter(asset => asset.id !== id);
        },
        getAvailableId(state, id) {
            state.availableId = id
        },
        async createOrUpdateCustomAsset(state, newData) {
            const currentDate = new Date();
            newData.dateUpdated = currentDate.toISOString().slice(0, 19).replace('T', ' ');

            // Determine value and param based on asset type
            switch (newData.type) {
                case 'keyword':
                    newData.value = newData.keywordField;
                    newData.param = `&kw=${newData.id}`;
                    break;
                case 'product_name':
                    newData.value = newData.keywordField;
                    newData.param = `&pn=${newData.id}`;
                    break;
                case 'background':
                    newData.value = newData.imageFileName;
                    newData.param = `&img=${newData.id}`;
                    break;
                case 'product_image':
                    newData.value = newData.imageFileName;
                    newData.param = `&pi=${newData.id}`;
                    break;
                default:
                    console.warn(`Unknown asset type: ${newData.type}`);
                    return; // Exit early if type is unrecognized
            }

            // Set access based on affiliateId
            if (newData.affiliateId) {
                newData.access = `Private(${newData.affiliateId})`;
            } else {
                newData.access = `Public`;
            }

            // Assign tags and preSignedUrl
            newData.tags = newData.selectedTagsObj;
            newData.preSignedUrl = newData.imageUrl;

            // Update state
            if (newData.isEdit) {
                state.customAssets.data = state.customAssets.data.map(asset =>
                  asset.id === newData.id ? newData : asset
                );
            } else {
                state.customAssets.count = state.customAssets.count || 1;
                state.customAssets.data.push(newData);
            }
        }
    },
    actions: {
        async getCustomAssetsStore({commit}, data) {

            const pagination = {
                limit: data.limit,
                page: data.page
            }
            const sorting = {
                orderBy: data.orderBy,
                orderDirectionAsc: data.orderDirectionAsc
            }
            const filters = data.filters
            try {
                const resp = await customAssetsApi.getCustomAssets(pagination, sorting, filters)
                commit('getCustomAssets',resp);
                return resp;
            } catch (e) {
                console.error('getCustomAssetsStore Error:',e)
            }
        },

        async getCustomAssetsFilterDataStore({commit}, data) {
            try {
                const resp = await customAssetsApi.getCustomAssetsFilterData(data)
                commit('getCustomAssetsFilterData',resp);
                return resp;
            } catch (e) {
                console.error('getCustomAssetsFilterDataStore Error:',e)
            }
        },
        getCustomAssetsTagsStore({commit}) {
            try {
                const resp = customAssetsApi.getCustomAssetsTags()
                commit('getCustomAssetsTags',resp);
            } catch (e) {
                console.error('getCustomAssetsTagsStore Error:',e)
            }
        },
        async createOrUpdateCustomAssetsStore({commit}, data) {
            try {
                const resp = await customAssetsApi.createOrUpdateCustomAssets(data)
                if (!resp.isSuccess && resp.id === null) {
                    alert('Error creating custom asset on backend')
                    return false;
                }

                if (data.type === 'keyword' || data.type === 'product_name') {

                    const headLineData = {
                        id: resp.id,
                        filename: data.name,
                        text: data.keywordField,
                        type: data.type,
                        extension: 'json'
                    }
                    console.log('headLineData',headLineData)
                    const sendFileToS3Resp = await customAssetsApi.sendFileToS3(headLineData)
                    console.log('sendFileToS3Resp',sendFileToS3Resp)

                }

                data.id = resp.id;
                commit('createOrUpdateCustomAsset',data);
                return true
            } catch (e) {
                console.error('getCustomAssetsStore Error:',e)
                return false;
            }
        },
        async deleteCustomAssetsStore({commit}, id) {
            try {
                const resp = await customAssetsApi.deleteCustomAssets(id)
                if (resp) {
                    commit('deleteCustomAsset',id);
                    return true
                } else {
                    return false
                }
            } catch (e) {
                console.error('deleteCustomAssetsStore Error:',e)
                return false;
            }
        },

        async getAvailableIdStore({commit}) {
            try {
                const resp = await customAssetsApi.getAvailableId()
                commit('getAvailableId',resp);
            } catch (e) {
                console.error('getAvailableIdStore Error:',e)
            }
        }


    },
    getters: {
        filters: state => state.filters,
        getCustomAssets: state => state.customAssets,
        getCustomAssetsTags: state => state.customAssetsTags,
        availableId: state => state.availableId,
    },

}
